import { useRef } from 'react'
import SearchableSelect from '../SearchableSelect'
import { searchPorts, type PortOption } from '../../lib/cardPorts'

// The discharge ports a rate card is quoted for ("for containers into Felixstowe / Southampton"),
// stored in pricing_rate_card_ports / supplier_rate_card_ports (20261003). Controlled: the parent
// owns the id list and saves it (see saveCardPorts). `ports` is 41k rows, so it is searched, not listed.

export default function CardPortsPicker({ value, onChange, disabled }: { value: PortOption[]; onChange: (v: PortOption[]) => void; disabled?: boolean }) {
  // SearchableSelect only reports the chosen id, so remember every search result to turn it back into a label.
  const seen = useRef(new Map<string, PortOption>())
  const search = async (term: string) => {
    const r = await searchPorts(term)
    r.forEach(o => seen.current.set(o.id, o))
    return r
  }
  return (
    <div>
      <div className="flex flex-wrap gap-1.5 mb-1.5">
        {value.length === 0 && <span className="text-xs text-gray-400">No ports set</span>}
        {value.map(p => (
          <span key={p.id} className="inline-flex items-center gap-1 rounded-full bg-blue-50 dark:bg-blue-900/30 text-blue-800 dark:text-blue-200 px-2 py-0.5 text-xs">
            {p.label}
            {!disabled && <button type="button" onClick={() => onChange(value.filter(x => x.id !== p.id))} className="text-blue-500 hover:text-red-600" aria-label={`Remove ${p.label}`}>×</button>}
          </span>
        ))}
      </div>
      {!disabled && (
        <SearchableSelect options={[]} value="" allowCreate={false} onSearch={search} placeholder="Add a port… (search by name or code)"
          onChange={id => {
            const found = id ? seen.current.get(id) : undefined
            if (found && !value.some(p => p.id === found.id)) onChange([...value, found])
          }} />
      )}
    </div>
  )
}
